import { WxShareInfo } from '@tencent/wphk-base-wx';
import { DialogListConfig, ModuleListConfig } from './module-type';

/** 支持区域 */
export enum AreaKey {
  /** 澳门 */
  Macao = 'Macao',
  /** 日本 */
  Japan = 'Japan',
  /** 中国大陆 */
  MainLand = 'MainLand',
}

/** 单区域 - 头图信息 */
export type AreaHeaderInfo = {
  /** 区域 */
  areaKey: AreaKey;
  /** 区域名 - 多语言 */
  areaName: string;
  /** 头图 Logo - 多语言 */
  headerLogo: string;
};

/**
 * 无极配置单区域基本信息
 * - 头图信息
 * - 热门商户信息（目前 HK）
 */
export type AreaWujiConfig = AreaHeaderInfo & {
  /** 热门商户（目前 HK） */
  hotMerchantListV2?: {
    list: string[];
  };
};

/**
 * 区域本地配置
 */
export type AreaLocalConfig = {
  /** 区域名 */
  name: string;
  /** 无极配置url 地址 */
  wujiConfigUrl: string;
  /** 模块列表配置 */
  moduleListConfig: ModuleListConfig;
  /** 弹窗列表配置 */
  dialogListConfig: DialogListConfig;
  /** 微信分享内容 */
  wxShareConf: WxShareInfo;
  /** 推荐图片 */
  recommendImg: string;
};
/**
 * 区域本地配置 - 带处理函数
 */
export type AreaLocalConfigWithHandler = { [key in AreaKey]: AreaLocalConfig & { moduleHandler: Function } };

export type RecommendList = { key: AreaKey; img: string };
